<template>
    <div class="clearfix">
       <Card class="shenpsx home_all">
          <p slot="title" class="home_all_title">
            <span class="home_all_title_shenpsx_icon"></span>
              审批事项
          </p>
          <ul class="home_all_ul">
              <li class="shenpsx_li home_all_li" v-for="(item,index) in shenpList" :key="index">
                  <span :class=item.icon></span>
                 <div class="home_all_li_div" @click="goto(item.url)">
                  <p :class="{'shenpsx_div_p': item.num > 0}">{{item.num}}</p>
                  <p>{{item.text}}</p>
                 </div>
              </li>
          </ul>
      </Card>
       <Card class="yujsx home_all">
          <p slot="title" class="home_all_title">
              <span class="home_all_title_yujsx_icon"></span>
              预警事项
          </p>
          <ul class="home_all_ul">
              <li class="home_all_li yujsx_li" v-for="(item,index) in yujList" :key="index">
                 <span :class=item.icon></span>
                 <div class="home_all_li_div" @click="goto(item.url)">
                  <p :class="{'yujsx_div_p': item.num > 0}">{{item.num}}</p>
                  <p>{{item.text}}</p>
                 </div>
              </li>
          </ul>
      </Card>
       <Card class="daibsx home_all">
          <p slot="title" class="home_all_title">
              <span class="home_all_title_daibsx_icon"></span>
              待办事项
          </p>
          <ul class="daibsx_ul">
              <li class="daibsx_li">
                  <span class="home_all_title_daibsx_icon_dingd"></span>
                 <div class="icon_daibsx_dashed_left"></div>
                 <div class="icon_daibsx_dashed_right first"></div>
                 <!-- <div class="icon_daibsx_solid"></div> -->
                 <!-- <div class="icon_daibsx_icon"></div> -->
                 <div @click="goto(shenpList[0].url)">
                   <!-- <div class="icon_daibsx_circular"> -->
                   <div class="icon_daibsx_circular_picture">
                      <span class="icon_daibsx_circular_first">{{shenpList[0].num}}</span>
                   </div>
                   <div class="daibsx_div" >
                    <p>{{shenpList[0].text}}</p>
                   </div>
                 </div>
              </li>
              <li class="daibsx_li">
                  <span class="home_all_title_daibsx_icon_paic"></span>
                 <div class="icon_daibsx_dashed_left first"></div>
                 <div class="icon_daibsx_dashed_right second"></div>
                 <div @click="goto(shenpList[1].url)">
                   <div class="icon_daibsx_circular_picture">
                      <span class="icon_daibsx_circular_second">{{shenpList[1].num}}</span>
                   </div>
                   <div class="daibsx_div" >
                    <p>{{shenpList[1].text}}</p>
                   </div>
                 </div>
              </li>
              <li class="daibsx_li">
                  <span class="home_all_title_daibsx_icon_shengc"></span>
                 <div class="icon_daibsx_dashed_left second"></div>
                 <div class="icon_daibsx_dashed_right third"></div>
                 <div @click="goto(shenpList[2].url)">
                   <div class="icon_daibsx_circular_picture">
                      <span class="icon_daibsx_circular_third">{{shenpList[2].num}}</span>
                   </div>
                   <div class="daibsx_div" >
                    <p>{{shenpList[2].text}}</p>
                   </div>
                 </div>
              </li>
              <li class="daibsx_li">
                  <span class="home_all_title_daibsx_icon_yiy"></span>
                 <div class="icon_daibsx_dashed_left third"></div>
                 <div class="icon_daibsx_dashed_right fourth"></div>
                 <div @click="goto(shenpList[3].url)">
                   <div class="icon_daibsx_circular_picture">
                      <span class="icon_daibsx_circular_fourth">{{shenpList[3].num}}</span>
                   </div>
                   <div class="daibsx_div" >
                    <p>{{shenpList[3].text}}</p>
                   </div>
                 </div>
              </li>
              <li class="daibsx_li">
                  <span class="home_all_title_daibsx_icon_chuk"></span>
                 <div class="icon_daibsx_dashed_left fourth"></div>
                 <div class="icon_daibsx_dashed_right fifth"></div>
                 <div @click="goto(shenpList[4].url)">
                   <div class="icon_daibsx_circular_picture">
                      <span class="icon_daibsx_circular_fifth">{{shenpList[4].num}}</span>
                   </div>
                   <div class="daibsx_div" >
                    <p>{{shenpList[4].text}}</p>
                   </div>
                 </div>
              </li>
              <li class="daibsx_li">
                  <span class="home_all_title_daibsx_icon_jies"></span>
                 <div class="icon_daibsx_dashed_left fifth"></div>
                 <div class="icon_daibsx_dashed_right"></div>
                 <div @click="goto(shenpList[5].url)">
                   <div class="icon_daibsx_circular_picture">
                      <span class="icon_daibsx_circular_sixth">{{shenpList[5].num}}</span>
                   </div>
                   <div class="daibsx_div" >
                    <p>{{shenpList[5].text}}</p>
                   </div>
                 </div>
              </li>
          </ul>
      </Card>
       <div class="home_all jinri_card">
          <ul class="jinri_ul">
              <li class="jinri_li_new" :class=item.bgc v-for="(item,index) in todayList" :key="index">
                  <div class="jinri_li_title">{{item.title}}</div>
                 <div class="jinri_li_progress">
                  <progress-card :allNum=item.allNum  :overNum=item.overNum></progress-card>
                 </div>
                 <div class="jinri_li_circular">
                  <i-circle :percent="item.allNum,item.overNum | numValue" :size="97">
                      <p class="jinri_li_circular_span">{{item.allNum,item.overNum | numValue}}%</p>
                      <p class="jinri_li_circular_text">排产负荷</p>
                  </i-circle>
                 </div>
              </li>
              <!-- <li class="jinri_li" v-for="(item,index) in todayList" :key="index">
                 <div class="jinri_li_dingbu"></div>
                 <div class="jinri_li_zuoshang"></div>
                 <div class="jinri_li_title">{{item.title}}</div>
                 <div class="jinri_li_bottom"></div>
                 <div class="jinri_li_progress">
                  <progress-card :allNum=item.allNum  :overNum=item.overNum></progress-card>
                 </div>
                 <div class="jinri_li_circular">
                  <i-circle :percent="item.allNum,item.overNum | numValue" :size="97">
                      <p class="jinri_li_circular_span">{{item.allNum,item.overNum | numValue}}%</p>
                      <p class="jinri_li_circular_text">排产负荷</p>
                  </i-circle>
                 </div>
              </li> -->
          </ul>
      </div>
    </div>

</template>
<style scoped lang="scss">
  .jrzq{
    background: url(../../assets/img/home_clockbg_2.png) left top no-repeat;
  }
  .jrhq{
    background: url(../../assets/img/home_clockbg_3.png) left top no-repeat;
  }
  .jrcc{
    background: url(../../assets/img/home_clockbg_4.png) left top no-repeat;
  }
  .jinri_li_new{
    margin-top:3px;
    width:210px;
    border:none;
    border-radius:4px;
    height:260px;
    position:relative;
    .jinri_li_title{
      color:#fff;
      position:absolute;
      left:50%;
      top:3px;
      transform:translateX(-50%);
    }
    .jinri_li_progress{
      margin-top:40px;
      padding:15px;
    }
    .jinri_li_circular{
      width:130px;
      height:77px;
      padding-left:33px;
      margin-top:-10px;
      .jinri_li_circular_span{
        color:#fff;
        font-size:24px;
      }
      .jinri_li_circular_text{
        color:#fff;
        font-size:16px;
      }
    }
  }
  .icon_daibsx_circular_picture{
    cursor:pointer;
    position:relative;
    width:50px;
    height:83px;
    margin-left:30px;
    background: url(../../assets/img/home_clockbg_1.png) left top no-repeat;
    span{
      font-size:18px;
      font-weight:300;
      width:50px;
      height:20px;
      text-align:center;
      line-height:20px;
      position:absolute;
      left:0px;
      top:50px;
    }
  }
  .home_all_title_daibsx_icon_dingd{
    display: inline-block;
    margin-top:0px;
    margin-left:8px;
    width:32px;
    height:32px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_dddpc.png) left top no-repeat;
  }
  .home_all_title_daibsx_icon_paic{
    display: inline-block;
    margin-top:0px;
    margin-left:8px;
    width:32px;
    height:32px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_pcdjg.png) left top no-repeat;
  }
  .home_all_title_daibsx_icon_shengc{
    display: inline-block;
    margin-top:0px;
    margin-left:2px;
    width:32px;
    height:32px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_scdrk.png) left top no-repeat;
  }
  .home_all_title_daibsx_icon_yiy{
    display: inline-block;
    margin-top:0px;
    margin-left:2px;
    width:29px;
    height:33px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_yydcl.png) left top no-repeat;
  }
  .home_all_title_daibsx_icon_chuk{
    display: inline-block;
    margin-top:0px;
    margin-left:2px;
    width:34px;
    height:32px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_ckdkd.png) left top no-repeat;
  }
  .home_all_title_daibsx_icon_jies{
    display: inline-block;
    margin-top:0px;
    margin-left:2px;
    width:33px;
    height:33px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_jsdrk.png) left top no-repeat;
  }
  .cghtsp{
    background: url(../../assets/icons/home_cghtsp32.png) left top no-repeat;
  }
  .xshtsp{
    background: url(../../assets/icons/home_xshtsp32.png) left top no-repeat;
  }
  .cgfpsp{
    background: url(../../assets/icons/home_cgfpsp32.png) left top no-repeat;
  }
  .cgrksp{
    background: url(../../assets/icons/home_cgrksp32.png) left top no-repeat;
  }
  .fksqsp{
    background: url(../../assets/icons/home_fksqsp32.png) left top no-repeat;
  }
  .xstdsp{
    background: url(../../assets/icons/home_xstdsp32.png) left top no-repeat;
  }
  .xsjssp{
    background: url(../../assets/icons/home_xsjssp32.png) left top no-repeat;
  }
  .xscksp{
    background: url(../../assets/icons/home_xscksp32.png) left top no-repeat;
  }
  .klyj{
    background: url(../../assets/icons/home_klyj32.png) left top no-repeat;
  }
  .aqkcyj{
    background: url(../../assets/icons/home_aqkcyj32.png) left top no-repeat;
  }
  .ccnlyj{
    background: url(../../assets/icons/home_ccnlyj32.png) left top no-repeat;
  }
  .yszkyj{
    background: url(../../assets/icons/home_yszkyj32.png) left top no-repeat;
  }
  .jhyj{
    background: url(../../assets/icons/home_jhyj32.png) left top no-repeat;
  }
  .yqwjsyj{
    background: url(../../assets/icons/home_yqwjsyj32.png) left top no-repeat;
  }
  .sxedyqyj{
    background: url(../../assets/icons/home_sxedyqyj32.png) left top no-repeat;
  }
  .shyj{
    background: url(../../assets/icons/home_shyj32.png) left top no-repeat;
  }

  .home_all_title_shenpsx_icon{
    display: inline-block;
    margin-right:10px;
    width:18px;
    height:18px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_titlespsx.png) left top no-repeat;
  }
  .shenpsx_li{
   span{
    display: inline-block;
    margin-top:30px;
    margin-left:14px;
    width:32px;
    height:32px;
    vertical-align: bottom;
   }
  }
  .yujsx_li{
   span{
    display: inline-block;
    margin-top:30px;
    margin-left:10px;
    width:32px;
    height:32px;
    vertical-align: bottom;
   }
  }
  .home_all_title_yujsx_icon{
    display: inline-block;
    margin-right:10px;
    width:18px;
    height:18px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_titleyjsx.png) left top no-repeat;
  }
  .home_all_title_daibsx_icon{
    display: inline-block;
    margin-right:10px;
    width:18px;
    height:18px;
    vertical-align: bottom;
    background: url(../../assets/icons/home_titledbsx.png) left top no-repeat;
  }
  .clearfix{
    width:1320px;
    margin:0 auto;
    margin-bottom:50px;
    &:after {
      content: ".";
      display: block;
      height: 0;
      visibility: hidden;
      clear: both;
    }
  }
  .shenpsx{border-left:5px solid skyblue !important;}
  .yujsx{border-left:5px solid red !important;}
  .daibsx{border-left:5px solid #ff9138 !important;}
  .home_all{
    min-width:650px;
    min-height:260px;
    float:left;
    width:48%;
    margin:20px 5px;
    background-color: rgba(99,99,99,0.8);
    border:none;
    .home_all_title{
      font-size:15px;
      font-weight: 100;
      i{
        width:20px;
        height:20px;
      }
    }
    p{
      color:#fff;
    }
    i{
      color:#fff;
    }
    .home_all_ul{
      display:flex;
      justify-content: space-between;
      flex-flow:wrap;
    }
    .home_all_li{
      flex: 0 0 24.8%;
      height:90px;
      margin-bottom:1px;
      position:relative;
      border:1px solid #fff;
      list-style-type:none;    
      background-color: rgba(33,33,33,0.8);
      .icon_shenpsx{
        position: absolute;
        top: 50%;
        left:5px;
        transform: translateY(-50%);
        width:35px;
        height:35px;
      }
      .home_all_li_div{
       position: absolute;
        top: 50%;
        left:40px;
        transform: translateY(-50%);
        width:108px;
        height:40px;
        cursor:pointer;
       :hover{color:#57a3f3;}
        p{text-align:center;margin:0;font-size:12px;}
        .shenpsx_div_p{color:#22c3f9;}
        .yujsx_div_p{color:#fe4c4c;}
      }
    }
  }
  .jinri_card{
    //border: 1px solid #dddee1;
    //border-color: #e9eaec;
    border-radius: 4px;
    font-size: 14px;
    .jinri_ul{
      margin:0;
      list-style-type:none;
      display:flex;
      justify-content: space-between;
      background-color: rgba(33,33,33,0.8);
    }
  }
  .daibsx_ul{
    margin-left:-20px;
    display:flex;
    list-style-type:none;
    justify-content: space-between;
    .daibsx_li{
      position:relative;
      min-width:110px;
      height:150px;
      flex:1;
      text-align:center;
      //.icon_daibsx{
       //width:30px;
        //height:35px;
        //border:1px solid red;
      //}
      .icon_daibsx_dashed_left{
        width:40px;
        height:1px;
        //border-top:1px dashed #20c5fb;
        position:absolute;
        top:20px;
        left:0px;
      }
      .icon_daibsx_dashed_right{
        width:40px;
        height:1px;
        //border-top:1px dashed #20c5fb;
        position:absolute;
        top:20px;
        left:70px;
        //transform: translateX(-50%);
      }
      .first{
        border-top:1px dashed #20c5fb;
      }
      .second{
        border-top:1px dashed #7dd521;
      }
      .third{
        border-top:1px dashed #f5a625;
      }
      .fourth{
        border-top:1px dashed #fe4c4c;
      }
      .fifth{
        border-top:1px dashed #279a9f;
      }
      .sixth{
        border-top:1px dashed #45da64;
      }
      .icon_daibsx_circular_first{
        color:#20c5fb;
      }
      .icon_daibsx_circular_second{
        color:#7dd521;
      }
      .icon_daibsx_circular_third{
        color:#f5a625;
      }
      .icon_daibsx_circular_fourth{
        color:#fe4c4c;
      }
      .icon_daibsx_circular_fifth{
        color:#279a9f;
      }
      .icon_daibsx_circular_sixth{
        color:#45da64;
      }
      //.icon_daibsx_solid{
        //position:absolute;
        //top:35px;
        //left:50%;
        //transform: translateX(-50%);
        //width:3px;
        //height:20px;
        //border:none;
        //background-color:#3a3b3d;
        //background-color:red;
      //}
      //.icon_daibsx_icon{
        //position:absolute;
        //top:55px;
        //left:50%;
        //transform: translateX(-50%);
        //width:15px;
        //height:15px;
        //background: url(../../assets/img/tip.png) left top no-repeat;
      //}
      //.icon_daibsx_circular{
        //position:absolute;
        //top:70px;
        //left:50%;
        //transform: translateX(-50%);
        //width:50px;
        //height:50px;
        //line-height:50px;
        //border-radius:50%;
        //border:1px solid #fff;
        //background-color: rgba(33,33,33,0.8);
        //span{
          //font-size:18px;
          //font-weight:300;
        //}
      //}
      .daibsx_div{
        cursor:pointer;
        position:absolute;
        top:130px;
        left:50%;
        transform: translateX(-50%);
        height:30px;
        width:100px;
      }
    }
  }
</style>
<script>
  import progressCard from '../../components/progressCard'
  //import api from '../../api/apinew'

  export default{
    data(){
      return {
        shenpList:[
          {
            icon:'cghtsp',
            url:'SystemManagement',
            text:'采购合同审批',
            num:'0'
          },
          {
            icon:'xshtsp',
            url:'SystemManagement',
            text:'销售合同审批',
            num:'1'
          },
          {
            icon:'cgfpsp',
            url:'SystemManagement',
            text:'采购发票审批',
            num:'2'
          },
          {
            icon:'cgrksp',
            url:'SystemManagement',
            text:'采购入库审批',
            num:'3'
          },
          {
            icon:'fksqsp',
            url:'SystemManagement',
            text:'付款申请审批',
            num:'4'
          },
          {
            icon:'xstdsp',
            url:'SystemManagement',
            text:'销售提单审批',
            num:'55'
          },
          {
            icon:'xsjssp',
            url:'SystemManagement',
            text:'销售结算审批',
            num:'6'
          },
          {
            icon:'xscksp',
            url:'SystemManagement',
            text:'销售出库审批',
            num:'77'
          },
        ],
        yujList:[
          {
            icon:'klyj',
            url:'SystemManagement',
            text:'库龄预警',
            num:'0'
          },
          {
            icon:'aqkcyj',
            url:'SystemManagement',
            text:'安全库存预警',
            num:'1'
          },
          {
            icon:'ccnlyj',
            url:'SystemManagement',
            text:'仓储能力预警',
            num:'2'
          },
          {
            icon:'yszkyj',
            url:'SystemManagement',
            text:'应收账款预警',
            num:'3'
          },
          {
            icon:'jhyj',
            url:'SystemManagement',
            text:'交货预警',
            num:'4'
          },
          {
            icon:'yqwjsyj',
            url:'SystemManagement',
            text:'预期未结算预警',
            num:'55'
          },
          {
            icon:'sxedyqyj',
            url:'SystemManagement',
            text:'授信额度预期预警',
            num:'6'
          },
          {
            icon:'shyj',
            url:'SystemManagement',
            text:'收货预警',
            num:'77'
          },
        ],
        todayList:[
          {
            bgc:'jrzq',
            title:'今日纵切',
            allNum:'100',
            overNum:'100',
          },
          {
            bgc:'jrhq',
            title:'今日横切',
            allNum:'500',
            overNum:'200',
          },
          {
            bgc:'jrcc',
            title:'今日冲床',
            allNum:'600',
            overNum:'500',
          },
        ],
      }
    },
    methods:{
      goto(url){
        this.$router.push(url)
      }
    },
    mounted: function () {
    },
    components: {
      progressCard
    },
    filters:{
      numValue(allNum,overNum){
        return Math.round(overNum/allNum*100)
      }
    },

  }
</script>



// WEBPACK FOOTER //
// index.vue?06d844d6